import * as paymentRequestSelectors from "@rentiohq/shared-frontend/dist/reduxV2/paymentRequest/paymentRequest.selectors";
import { connect } from "react-redux";
import { IRootState } from "../../../../redux/reducers";
import PaymentRequestRedirect from "./PaymentRequestRedirect";
import { IProps, IStateProps } from "./PaymentRequestRedirect.types";

const mapStateToProps = (state: IRootState, props: IProps): IStateProps => {
  const { id } = props;

  return {
    paymentRequest: paymentRequestSelectors.getDetail(state, id),
  };
};

// eslint-disable-next-line import/no-default-export
export default connect<IStateProps, {}, IProps, IRootState>(mapStateToProps)(
  PaymentRequestRedirect,
);
